export function formatSpecifications(content: string, language: 'nl' | 'en'): string {
  const lines = content.split('\n');
  
  const needsHeader = content.toLowerCase().includes('afmeting') || 
                     content.toLowerCase().includes('dimension');
                     
  const header = language === 'nl' ? 'Specificaties:' : 'Specifications:';
  
  const formattedContent = lines
    .map(line => {
      if (line.includes(':')) {
        const [label, value] = line.split(':');
        return `${label.trim()}: ${value.trim()}`;
      }
      return line.trim();
    })
    .join('\n');
    
  return needsHeader
    ? `${header}\n\n${formattedContent}`
    : formattedContent;
}